import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import { axiosInstance, axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";
import GetQueryParams from "../../../Utils/GetQueryParams";
import { TABLE_CACHE_EXPIRY_MS } from "../../../config/cacheConfig";
import moment from "moment";

const initialState = {
  Leads: [],
  SingleLeads: [],
  RottenDays: null,
  LeadsPopulate: [],
  LeadsActivityType: [],
  LeadsActivitySubTypes: [],
  LeadsAffliate: [],
  TranferingLeads: [],
  LeadsUsers: [],
  LeadsPersons: [],
  LeadsByPiplineStage: [],
  DeletedLeads: [],
  LeadWonPopulate: [],
  TransferUsers: [],
  LeadsNotes: null,
  LeadsFiles: null,
  isSuccess: false,
  LeadUnitCounts: 0,
  message: null,
  totalCount: 0,
  LeadCommPaidDetail: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status1: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status2: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status3: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status4: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  status5: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,

  tableCache: {
    byPipeline: {},
    cacheExpiry: TABLE_CACHE_EXPIRY_MS,
    activeCacheKey: null,
  },
};

const generateTableCacheKey = (pipelineId, queryParams) => {
  if (!pipelineId) {
    return null;
  }

  const normalizedParams = {
    PageNumber: queryParams?.PageNumber || 1,
    PageSize: queryParams?.PageSize || 50,
    title: queryParams?.title || "",
    projectId: queryParams?.projectId || "",
    userid: queryParams?.userid || "",
    groupId: queryParams?.groupId || "",
    personId: queryParams?.personId || "",
    leadValue: queryParams?.leadValue || "",
    leadSourceId: queryParams?.leadSourceId || "",
    pipelineStageId: queryParams?.pipelineStageId || "",
    leadId: queryParams?.leadId || "",
  };
  const sortedParams = Object.keys(normalizedParams)
    .sort()
    .reduce((acc, key) => {
      acc[key] = normalizedParams[key];
      return acc;
    }, {});

  const queryString = JSON.stringify(sortedParams);
  const cacheKey = `pipeline_${pipelineId}_${queryString}`;

  return cacheKey;
};

const buildLeadsQueryParams = (filters = {}, pageNo = 1, pageSize = 50) => {
  let salespersonIds = [];

  if (filters?.salesperson) {
    if (Array.isArray(filters.salesperson)) {
      salespersonIds = filters.salesperson.map(sp => sp?.Id || sp?.id).filter(id => id != null && id !== "");
    } else if (typeof filters.salesperson === "string") {
      salespersonIds = [filters.salesperson].filter(id => id);
    }
  }

  return {
    PageNumber: pageNo,
    PageSize: pageSize,
    title: filters?.subject || "",
    projectId: filters?.project || "",
    userid: salespersonIds.length ? JSON.stringify(salespersonIds) : "",
    groupId: filters?.group || "",
    personId: filters?.person || "",
    leadValue: filters?.leadValue || "",
    leadSourceId: filters?.leadSource || "",
    pipelineStageId: filters?.stage || "",
    leadId: filters?.id || "",
  };
};

const hasCacheForQuery = (state, pipelineId, queryParams) => {
  const cacheKey = generateTableCacheKey(pipelineId, queryParams);
  if (!cacheKey) return false;

  const cachedData = state.Leads.tableCache.byPipeline[cacheKey];
  return cachedData && isTableCacheValid(cachedData, state.Leads.tableCache.cacheExpiry);
};

const isTableCacheValid = (cachedEntry, cacheExpiry) => {
  if (!cachedEntry || !cachedEntry.timestamp) {
    return false;
  }

  const currentTime = Date.now();
  const cacheAge = currentTime - cachedEntry.timestamp;
  const isValid = cacheAge < cacheExpiry;

  return isValid;
};

export const fetchLeads = createAsyncThunk(
  "/Lead/ByPipeline",
  async (
    payload,
    {
      // getState,
      dispatch,
    }
  ) => {
    // const state = getState();
    // const leadsSlice = state.Leads;

    const cacheKey = generateTableCacheKey(payload?.id, payload?.queryParams);

    // if (cacheKey) {
    //   const cachedData = leadsSlice.tableCache.byPipeline[cacheKey];

    //   if (cachedData && isTableCacheValid(cachedData, leadsSlice.tableCache.cacheExpiry)) {
    //     dispatch(setActiveCacheKey(cacheKey));

    //     return {
    //       ...cachedData.data,
    //       fromCache: true,
    //       cacheKey: cacheKey,
    //     };
    //   }
    // } else {
    //   console.log("⚠️ No cache key generated, fetching fresh data");
    // }

    const queryParams = GetQueryParams(payload?.queryParams);

    try {
      const response = await axiosInstance.get(`/Lead/ByPipeline/${payload?.id}?${queryParams}`);

      const isSuccess = response.data?.Succeeded;
      const result = {
        ...response.data,
        fromCache: false,
        cacheKey: cacheKey,
      };

      if (isSuccess && cacheKey) {
        dispatch(
          updateTableCache({
            key: cacheKey,
            data: response.data,
          })
        );
      } else if (!isSuccess) {
        // console.log("⚠️ API response not successful, not caching");
      }

      return result;
    } catch (error) {
      console.error("❌ Error fetching leads:", error);
      console.error("📞 API endpoint called:", `/Lead/ByPipeline/${payload?.id}?${queryParams}`);
      throw error;
    }
  }
);

// export const fetchLeads = createAsyncThunk(
//   // "/Lead",
//   "/Lead/ByPipeline",
//   async payload => {
//     const queryParams = GetQueryParams(payload?.queryParams);

//     const response = await axiosInstance.get(`/Lead/ByPipeline/${payload?.id}?${queryParams}`);
//     return response.data;
//   }
// );

export const fetchLeadsSingle = createAsyncThunk("/Lead/{id}", async id => {
  const response = await axiosInstance.get(`/Lead/${Number(id)}`);

  return response.data;
});
export const fetchLeadsbyNotificationId = createAsyncThunk("/Lead/LeadInfo/{NotificationId}", async id => {
  const response = await axiosInstance.get(`/Lead/LeadInfo/${id}`);
  return response.data;
});
export const fetchTranferingLeadbyUser = createAsyncThunk("/Lead/UserLead", async id => {
  const response = await axiosInstance.get(`/Lead/UserLeads?userId=${id}`);

  return response.data;
});

export const fetchLeadsPopulate = createAsyncThunk("/Lead/Populate", async id => {
  const response = await axiosInstance.get(`/Lead/Populate${id ? `?excludeLeadId=${id}` : ""}`);

  return response.data;
});
////////
export const fetchusers = createAsyncThunk("/Users", async () => {
  const response = await axiosInstanceAuth.get(`/Users`);
  return response;
});

export const fetchLeadsNotes = createAsyncThunk("/LeadNotes", async () => {
  const response = await axiosInstance.get(`/LeadNotes`);

  return response.data;
});

export const fetchLeadsFiles = createAsyncThunk("/LeadFiles", async () => {
  const response = await axiosInstance.get(`/LeadFiles`);

  return response.data;
});

export const fetchLeadsCommPaid = createAsyncThunk(
  "CommissionTemplate/GetPaidCommission/{NotificationId}",
  async id => {
    const response = await axiosInstance.get(`CommissionTemplate/GetPaidCommission/${id}`);

    return response.data;
  }
);

// export const fetchLeadActivityTypePopulate = createAsyncThunk(
//   "/ActivtyType",
//   async () => {
//     const response = await axiosInstance.get(`/ActivtyType`);

//     return response;
//   }
// );

export const fetchleadActivityTypePopulate = createAsyncThunk("/ActivtyTypePapulate", async LeadId => {
  if (LeadId) {
    const response = await axiosInstance.get(`/LeadActivities/PopulateActivity?LeadId=${LeadId}`);
    return response.data;
  } else {
    const response = await axiosInstance.get(`/LeadActivities/PopulateActivity`);
    return response.data;
  }
});
export const fetchLeadByPiplineStage = createAsyncThunk("/Lead/ByPipelineStage", async id => {
  const response = await axiosInstance.get(`/Lead/ByPipelineStage/${id}`);
  return response.data;
});

export const fetchDeletedLeadsData = createAsyncThunk("/Lead/GetDeletedLeads", async pipelineId => {
  const response = await axiosInstance.get(`/Lead/GetDeletedLeads?pipelineId=${pipelineId}`);

  return response.data;
});
export const fetchLeadWonPopulate = createAsyncThunk("/Lead/PopulateLeadWon", async id => {
  const response = await axiosInstance.get(`/Lead/PopulateLeadWon?leadId=${id}`);
  return response.data;
});

const Leadslice = createSlice({
  name: "Leads",
  initialState,
  reducers: {
    LeadsAdded: {
      reducer(state, action) {
        state.Leads?.push(action.payload);
      },
    },

    updateTableCache: (state, action) => {
      const { key, data } = action.payload;

      // console.log("💾 updateTableCache called with:", { key, hasData: !!data });

      if (!key || !data) {
        console.warn("⚠️ updateTableCache called with invalid key or data");
        return;
      }

      const newCacheEntry = {
        data: { ...data },
        timestamp: Date.now(),
        totalRecords: data.TotalRecords || data.totalRecords || 0,
      };
      state.tableCache.byPipeline = {
        ...state.tableCache.byPipeline,
        [key]: newCacheEntry,
      };

      state.tableCache.activeCacheKey = key;
    },

    invalidateTableCache: (state, action) => {
      const { pipelineId, specificKey } = action.payload || {};

      if (specificKey) {
        delete state.tableCache.byPipeline[specificKey];
      } else if (pipelineId) {
        Object.keys(state.tableCache.byPipeline).forEach(key => {
          if (key.startsWith(`pipeline_${pipelineId}_`)) {
            delete state.tableCache.byPipeline[key];
          }
        });
      } else {
        state.tableCache.byPipeline = {};
      }
      state.tableCache.activeCacheKey = null;
    },

    clearTableCache: state => {
      state.tableCache.byPipeline = {};
      state.tableCache.activeCacheKey = null;
    },

    setActiveCacheKey: (state, action) => {
      state.tableCache.activeCacheKey = action.payload;
    },

    setTableCacheExpiry: (state, action) => {
      state.tableCache.cacheExpiry = action.payload;
    },

    updateLeadInTableCache: (state, action) => {
      const { leadId, updatedData } = action.payload;
      const cacheKey = state.tableCache.activeCacheKey;

      if (cacheKey && state.tableCache.byPipeline[cacheKey]) {
        const cachedData = state.tableCache.byPipeline[cacheKey];
        if (cachedData.data?.Data) {
          const updatedLeads = cachedData.data.Data.map(lead =>
            lead.Id === leadId ? { ...lead, ...updatedData } : lead
          );
          cachedData.data.Data = updatedLeads;
          cachedData.timestamp = Date.now();
        }
      }
    },

    removeLeadFromTableCache: (state, action) => {
      const { leadId } = action.payload;
      const cacheKey = state.tableCache.activeCacheKey;

      if (cacheKey && state.tableCache.byPipeline[cacheKey]) {
        const cachedData = state.tableCache.byPipeline[cacheKey];
        if (cachedData.data?.Data) {
          cachedData.data.Data = cachedData.data.Data.filter(lead => lead.Id !== leadId);
          cachedData.data.TotalRecords = cachedData.data.TotalRecords - 1;
          cachedData.timestamp = Date.now();
        }
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchLeads.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchLeads.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Leads = {
          ...action.payload,
          fromCache: undefined,
          cacheKey: undefined,
        };
        if (action.payload.cacheKey && !action.payload.fromCache) {
          state.tableCache.activeCacheKey = action.payload.cacheKey;
        }
      })
      .addCase(fetchLeads.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
        state.Leads = null;
      })
      //
      .addCase(fetchusers.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchusers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.TransferUsers = action.payload.data;
      })
      .addCase(fetchusers.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
        state.TransferUsers = null;
      })
      //
      .addCase(fetchLeadWonPopulate.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchLeadWonPopulate.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadUnitCounts = action.payload.LeadUnitCounts;
        state.LeadWonPopulate = action.payload.Data;
      })
      .addCase(fetchLeadWonPopulate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchLeadsSingle.pending, state => {
        state.status1 = "loading";
      })
      .addCase(fetchLeadsSingle.fulfilled, (state, action) => {
        state.status1 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.SingleLeads = action.payload.Data;
        state.RottenDays = action.payload.RottenDays;
      })
      .addCase(fetchLeadsSingle.rejected, (state, action) => {
        state.error = action.error.message;
        state.status1 = "failed";
      })
      .addCase(fetchLeadsbyNotificationId.pending, state => {
        state.status1 = "loading";
      })
      .addCase(fetchLeadsbyNotificationId.fulfilled, (state, action) => {
        state.status1 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.SingleLeads = action.payload.Data;
        state.RottenDays = action.payload.RottenDays;
      })
      .addCase(fetchLeadsbyNotificationId.rejected, (state, action) => {
        state.error = action.error.message;
        state.status1 = "failed";
      })
      .addCase(fetchLeadsNotes.pending, state => {
        state.status2 = "loading";
      })
      .addCase(fetchLeadsNotes.fulfilled, (state, action) => {
        state.status2 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadsNotes = action.payload.Data;
      })
      .addCase(fetchLeadsNotes.rejected, (state, action) => {
        state.error = action.error.message;
        state.status2 = "failed";
      })
      .addCase(fetchLeadsFiles.pending, state => {
        state.status3 = "loading";
      })
      .addCase(fetchLeadsFiles.fulfilled, (state, action) => {
        state.status3 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadsFiles = action.payload.Data;
      })
      .addCase(fetchLeadsFiles.rejected, (state, action) => {
        state.error = action.error.message;
        state.status3 = "failed";
      })
      .addCase(fetchleadActivityTypePopulate.pending, state => {
        state.status3 = "loading";
      })
      .addCase(fetchleadActivityTypePopulate.fulfilled, (state, action) => {
        state.status3 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadsActivityType = action.payload?.Data?.activityTypesData;
        state.LeadsActivitySubTypes = action.payload?.Data?.activitySubTypesData || [];
        state.LeadsPersons = action.payload?.Data?.peronData;
        state.LeadsUsers = action.payload?.Data?.userData;
        state.LeadsAffliate = action.payload?.Data?.affiliateData;
      })
      .addCase(fetchleadActivityTypePopulate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status3 = "failed";
      })
      .addCase(fetchLeadsPopulate.pending, state => {
        state.status4 = "loading";
      })
      .addCase(fetchLeadsPopulate.fulfilled, (state, action) => {
        state.status4 = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadsPopulate = action.payload;
      })
      .addCase(fetchLeadsPopulate.rejected, (state, action) => {
        state.error = action.error.message;
        state.status4 = "failed";
      })
      .addCase(fetchLeadByPiplineStage.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchLeadByPiplineStage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadsByPiplineStage = action.payload.Data;
      })
      .addCase(fetchLeadByPiplineStage.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      })
      .addCase(fetchDeletedLeadsData.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchDeletedLeadsData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.DeletedLeads = action.payload.Data;
      })
      .addCase(fetchDeletedLeadsData.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
        state.DeletedLeads = [];
      })
      .addCase(fetchTranferingLeadbyUser.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchTranferingLeadbyUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.TranferingLeads = action.payload.Data;
      })
      .addCase(fetchTranferingLeadbyUser.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
        state.TranferingLeads = [];
      })
      .addCase(fetchLeadsCommPaid.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchLeadsCommPaid.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.LeadCommPaidDetail = action.payload.Data;
      })
      .addCase(fetchLeadsCommPaid.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
        state.LeadCommPaidDetail = [];
      });
  },
});
// ==============================================
// SELECTORS
// ==============================================
const selectCachedDataByKey = (state, cacheKey) => {
  if (!cacheKey) return null;
  return state.Leads.tableCache.byPipeline[cacheKey];
};
const selectLeadsTableCache = state => state.Leads.tableCache;
const selectRawLeads = state => state.Leads.Leads;

const selectTransformedLeads = createSelector(
  [selectLeadsTableCache, selectRawLeads],
  (tableCache, rawLeads) => {
    const activeKey = tableCache.activeCacheKey;
    let leadsData = [];
    let pageNumber = 1;
    let pageSize = 50;
    let totalRecords = 0;

    if (activeKey && tableCache.byPipeline[activeKey]) {
      const cached = tableCache.byPipeline[activeKey];
      leadsData = cached.data?.data || [];
      totalRecords = cached.totalRecords || 0;
      pageNumber = cached.data?.PageNumber || 1;
      pageSize = cached.data?.PageSize || 50;
    } else {
      leadsData = rawLeads?.data || [];
      pageNumber = rawLeads?.PageNumber || 1;
      pageSize = rawLeads?.PageSize || 50;
      totalRecords = rawLeads?.TotalRecords || 0;
    }

    const startIndex = (pageNumber - 1) * pageSize + 1;

    return {
      data: leadsData.map((lead, index) => ({
        ...lead,
        id: lead.Id,
        srNo: startIndex + index,
        LeadSource: lead.LeadSourceName || "N/A",
        LeadValue: lead.LeadValue,
        PipelineStage: lead.PipelineStageName || "N/A",
        PersonName: lead?.PersonName || "N/A",
        PersonId: lead?.PersonId,
        ExpectedCloseDate: moment(lead.ExpectedCloseDate).format("YYYY-MM-DD") || null,
        CreatedAt: lead.CreatedAt || null,
        Tags: lead?.LeadTags || [],
        Projects: lead?.Projects || [],
      })),
      totalRecords,
      pageNumber,
      pageSize,
    };
  }
);

const selectTotalRecords = state => state.Leads.Leads?.TotalRecords || 0;

const selectCurrentPageData = state => ({
  data: state.Leads.Leads?.data || [],
  totalRecords: state.Leads.Leads?.TotalRecords || 0,
  pageNumber: state.Leads.Leads?.PageNumber || 1,
  pageSize: state.Leads.Leads?.PageSize || 50,
  totalPages: state.Leads.Leads?.TotalPages || 0,
});

const selectIsFromCache = state => state.Leads.Leads?.fromCache || false;

const selectTableCache = state => state.Leads.tableCache;

const selectActiveCacheKey = state => state.Leads.tableCache.activeCacheKey;

const selectCacheStats = state => {
  const byPipeline = state.Leads.tableCache.byPipeline;
  const keys = Object.keys(byPipeline);

  return {
    totalEntries: keys.length,
    keys: keys,
    cacheExpiry: state.Leads.tableCache.cacheExpiry,
    activeKey: state.Leads.tableCache.activeCacheKey,
  };
};

const selectActiveCacheData = state => {
  const activeKey = state.Leads.tableCache.activeCacheKey;
  if (!activeKey) return null;

  const cached = state.Leads.tableCache.byPipeline[activeKey];
  if (!cached) return null;

  return {
    data: cached.data?.data || [],
    totalRecords: cached.totalRecords || 0,
    timestamp: cached.timestamp,
    age: Date.now() - cached.timestamp,
    isValid: isTableCacheValid(cached, state.Leads.tableCache.cacheExpiry),
  };
};
// ==============================================
// COMPLETE EXPORTS
// ==============================================

export {
  generateTableCacheKey,
  isTableCacheValid,
  buildLeadsQueryParams,
  hasCacheForQuery,
  selectCachedDataByKey,
  selectTransformedLeads,
  selectTotalRecords,
  selectCurrentPageData,
  selectIsFromCache,
  selectTableCache,
  selectActiveCacheKey,
  selectCacheStats,
  selectActiveCacheData,
};

export const getLeadPaidDetails = state => state.Leads.LeadCommPaidDetail;

export const getLeadsDetails = state => state.Leads;

export const {
  LeadsAdded,
  updateTableCache,
  invalidateTableCache,
  clearTableCache,
  setTableCacheExpiry,
  updateLeadInTableCache,
  removeLeadFromTableCache,
  setActiveCacheKey,
} = Leadslice.actions;

export default Leadslice.reducer;
